import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@niko-crm/ui';

/**
 * Keeps an already-authenticated user off `/login` (see the niko-crm twin for
 * the full rationale). The admin app has no tenant picker, so an authenticated
 * SuperAdmin goes straight to `/tenants`.
 *
 * The group check is NOT redundant with `superAdminGuard`: a non-SuperAdmin
 * with a valid Cognito session would otherwise bounce /login → /tenants →
 * /unauthorized. Sending them to `/unauthorized` directly gives them the
 * logout button in one hop.
 */
export const guestGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const payload = await authService.getTokenPayload();
  if (!payload) return true;

  const groups = (payload['cognito:groups'] as string[]) ?? [];
  return groups.includes('SuperAdmin')
    ? router.createUrlTree(['/tenants'])
    : router.createUrlTree(['/unauthorized']);
};
